
import { defineComponent, PropType } from 'vue'
import { similarArticleInfo } from '@/api/assist'

export default defineComponent({
  props: {
    similarArticleList: {
      type: Array as PropType<similarArticleInfo[]>,
      default: () => [],
    },
    similarTotal: {
      type: Number,
      default: 0,
    },
    sameTotal: {
      type: Number,
      default: 0,
    },
  },
  setup() {
    const goRp = (rdPaperId: string) => {
      window.open(`https://readpaper.com/paper/${rdPaperId}`, '_blank')
    }

    return {
      goRp,
    }
  },
  methods: {},
})
